'use client';
import cx from 'classnames';
import React, { useEffect } from 'react';
import { Button, Size, Theme } from '../Button';
import Grid from '../Grid';
import styles from './Error.module.scss';
const getErrorMessage = (statusCode) => {
    switch (statusCode) {
        case 'other':
            return `Sorry we can't find what you're looking for at the moment. Please bear with us, we'll be back soon!`;
        case 404:
            return 'Sorry, we can’t find the page you were looking for.';
        default:
            return 'Something went wrong! Please try again later.';
    }
};
export const Error = ({ statusCode, analytics, errorType, errorReason, onClick, customLinkProps, }) => {
    useEffect(() => {
        analytics({
            event: 'virtual page view',
            pageType: 'error',
            pageSubType: String(statusCode),
            pageName: `/ga-virtual/error/${statusCode}`,
            pageId: '(no id)',
            errorType: errorType || 'not available',
            errorReason: errorReason || 'not available',
        });
    }, [statusCode, analytics, errorType, errorReason]);
    const clickToCall = (number) => {
        analytics({
            event: 'visitor interaction',
            interactionName: 'click to call',
            phoneNumber: number,
        });
    };
    const buttonOnClick = onClick ? onClick : customLinkProps.onClick;
    return (<>
      <Grid.Container className={styles.error}>
        <Grid.Row align='center' justify='center' gutterY={30}>
          <Grid.Col xs={12} sm={7} md={6} lg={5} xl={4} gutterY={30}>
            <h1 className={cx(styles.mainTitle)}>Oops!</h1>
            <h2 className={styles.subTitle}>{getErrorMessage(statusCode)}</h2>
            {typeof statusCode !== 'string' && (<div className={styles.errorCode}>
                <strong>Error code: {statusCode}</strong>
              </div>)}
            <Button theme={Theme.PRIMARY_THEME} scale={Size.MEDIUM_SIZE} className={styles.button} useAnchor href='/' onClick={buttonOnClick}>
              Back to homepage
            </Button>
            <div className={styles.callMe}>Alternatively please call us on:</div>
            <div className={styles.phone}>
              <a className={styles.phoneNumber} onClick={() => clickToCall('03332025250')} href='tel:03332025250'>
                0333 202 5250
              </a>
              (Holidays)
            </div>
            <div className={styles.openHours}>Mon - Fri: 9am - 8pm, Sat - Sun: 9am - 7pm </div>
            <div className={styles.phone}>
              <a className={styles.phoneNumber} onClick={() => clickToCall('03332021460')} href='tel:03332021460'>
                0333 202 1460
              </a>
              (Ownership)
            </div>
            <div className={styles.openHours}>Mon - Fri: 9am - 6pm, Sat - Sun: 10am - 5pm</div>
          </Grid.Col>
          <Grid.Col xs={9} sm={6} md={4} lg={3} xl={4} gutterY={30} className={styles.illustration}>
            <img src={'http://www.haven.com/assets/icons/icecream.svg'} width='207' height='211' alt='dropped ice cream cone'/>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </>);
};
